// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-jxfzcx-jxJxfzcx-index-main_right_content-3RQ9v","table":"components-tjcx-jxfzcx-jxJxfzcx-index-table-aHy03"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/jxfzcx/jxJxfzcx/index.css
// module id = 2307
// module chunks = 0